webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GradeCalcPage__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GradeCalcPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_GradeCalcPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Cummulative__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Cummulative___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Cummulative__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Weight__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Weight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Weight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GPA__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GPA___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_GPA__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slider_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_slider_component__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Grade Calculator Page',
    component: __WEBPACK_IMPORTED_MODULE_2__components_GradeCalcPage___default.a
  }, {
    path: '/Cummulative',
    name: 'Cummulative Grade',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Cummulative___default.a
  }, {
    path: '/Weight',
    name: 'Weight Grade',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Weight___default.a
  }, {
    path: '/GPA',
    name: 'GPA',
    component: __WEBPACK_IMPORTED_MODULE_5__components_GPA___default.a
  }]
}));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(14)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(25),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Grade-Calculator',
  methods: {
    goToPage: function goToPage(nav) {
      this.$router.push('/' + nav);
    }
  }

});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cumm',
  data: function data() {
    return {
      grades: [{ "pointsEarned": "", "pointsTotal": "" }],
      predicts: [{ "pointsPredict": "" }],
      value: 0,
      earned: 0,
      total: 0,
      cummGrade: 0,
      predictedTotal: 0,
      predictedEarned: 0,
      predictedGrade: 0

    };
  },
  created: function created() {
    this.initGrades();
  },
  methods: {

    addGrade: function addGrade() {
      this.grades.push({ "pointsEarned": "", "pointsTotal": "" });
    },

    removeGrade: function removeGrade() {
      this.grades.pop();
    },

    initGrades: function initGrades() {
      for (var i = 0; i < 10; i++) {
        this.grades.push({ "pointsEarned": "", "pointsTotal": "" });
      }
      for (var j = 0; j < 5; j++) {
        this.predicts.push({ "pointsPredict": "" });
      }
    },

    resetEntries: function resetEntries() {
      for (var g in this.grades) {
        this.grades[g].pointsEarned = "";
        this.grades[g].pointsTotal = "";
      }
      this.cummGrade = "";
    },

    resetPred: function resetPred() {
      for (var p in this.predicts) {
        this.predicts[p].pointsPredict = "";
      }
      this.predictedGrade = "";
      this.value = 0;
    }
  },

  computed: {
    calculateGrade: function calculateGrade() {
      var earned = 0;
      var total = 0;
      for (var g in this.grades) {
        earned += Number(this.grades[g].pointsEarned);
        total += Number(this.grades[g].pointsTotal);
      }
      this.earned = earned;
      this.total = total;
      this.cummGrade = 100 * (earned / total);
      this.cummGrade = this.cummGrade.toFixed(2);

      if (isNaN(this.cummGrade)) {
        return 0;
      } else if (!isFinite(this.cummGrade)) {
        return 0;
      }
      return this.cummGrade;
    },

    predictGrade: function predictGrade() {
      this.predictedEarned = Number(this.earned);
      this.predictedTotal = Number(this.total);
      for (var p in this.predicts) {
        this.predictedTotal += Number(this.predicts[p].pointsPredict);
      }

      var need = 0;
      var val = this.value / 100.0;
      need = Math.ceil(val * this.predictedTotal - this.earned);
      this.predictedGrade = need;
      if (need < 0) {
        return 0;
      }
      return need;
    }
  },

  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gpa',
  data: function data() {
    return {
      grades: [{ "letter": "", "creditHours": "" }],
      final: [{ "creditHours": "" }],
      value: 3.01,
      gpaGrade: 0,
      totalCreditHours: 0,
      earnedGPAPoints: 0,
      predictedGPA: 0,
      prevGPA: 0,
      prevCreditHours: 0
    };
  },
  created: function created() {
    this.initGrades();
  },
  methods: {

    addGrade: function addGrade() {
      this.grades.push({ "letter": "", "creditHours": "" });
    },

    removeGrade: function removeGrade() {
      this.grades.pop();
    },

    initGrades: function initGrades() {
      for (var i = 0; i < 10; i++) {
        this.grades.push({ "letter": "", "creditHours": "" });
      }
      var val = 0;
      this.value = val.toFixed(2);
    },

    resetEntries: function resetEntries() {
      for (var g in this.grades) {
        this.grades[g].letter = "";
        this.grades[g].creditHours = "";
      }
      this.gpaGrade = 0;
      this.prevCreditHours = "";
      this.prevGPA = "";
    },

    resetPred: function resetPred() {

      this.final.creditHours = "";
      this.predictedGrade = "";
      this.value = 3.0;
    },

    convertToNumber: function convertToNumber(letter) {
      if (letter === "A" || letter === "a") {
        return 4.0;
      } else if (letter === "A-" || letter === "a-") {
        return 3.67;
      } else if (letter === "B+" || letter === "b+") {
        return 3.33;
      } else if (letter === "B" || letter === "b") {
        return 3.00;
      } else if (letter === "B-" || letter === "b-") {
        return 2.67;
      } else if (letter === "C+" || letter === "c+") {
        return 2.33;
      } else if (letter === "C" || letter === "c") {
        return 2.00;
      } else if (letter === "C-" || letter === "c-") {
        return 1.67;
      } else if (letter === "D+" || letter === "d+") {
        return 1.33;
      } else if (letter === "D" || letter === "d") {
        return 1.00;
      } else if (letter === "D-" || letter === "d-") {
        return 0.67;
      } else if (letter === "F" || letter === "f") {
        return 0.00;
      }
    }
  },

  computed: {
    calculateGrade: function calculateGrade() {

      var totalCreditHours = 0;
      var earnedGPAPoints = 0;

      if (this.prevGPA != "" && this.prevCreditHours != "") {
        earnedGPAPoints += Number(this.prevGPA) * Number(this.prevCreditHours);
        totalCreditHours += Number(this.prevCreditHours);
      }

      for (var g in this.grades) {
        if (this.grades[g].letter === "" || this.grades[g].creditHours === "") {
          continue;
        } else {
          earnedGPAPoints += this.convertToNumber(this.grades[g].letter) * Number(this.grades[g].creditHours);
          totalCreditHours += Number(this.grades[g].creditHours);
        }
      }

      this.totalCreditHours = totalCreditHours;
      this.earnedGPAPoints = earnedGPAPoints;

      var gpaGrade = parseFloat(earnedGPAPoints) / totalCreditHours;

      this.gpaGrade = gpaGrade.toFixed(3);

      console.log(this.gpaGrade);

      if (isNaN(this.gpaGrade)) {
        return 0;
      } else if (!isFinite(this.gpaGrade)) {
        return 0;
      }
      return this.gpaGrade;
    },

    predictGrade: function predictGrade() {

      var need = 0;
      var allCreditHours = this.totalCreditHours + Number(this.final.creditHours);

      need = (allCreditHours * this.value - this.earnedGPAPoints) / this.final.creditHours;
      need = need.toFixed(3);

      this.predictedGPA = need;

      if (need < 0) {
        return 0;
      } else if (!isFinite(need)) {
        return 0;
      } else if (need > 4.0) {
        return ">4.000";
      }
      return need;
    }
  },

  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gradeCalcPage'

});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'weight',
  data: function data() {
    return {
      grades: [{ "pointsEarned": "", "pointsTotal": "", "weight": "" }],
      final: [{ "finalTotal": "", "finalWeight": "" }],
      value: 0,
      weightSum: 0,
      earnedTotal: 0,
      weightGrade: 0

    };
  },
  created: function created() {
    this.initGrades();
  },
  methods: {

    addGrade: function addGrade() {
      this.grades.push({ "pointsEarned": "", "pointsTotal": "", "weight": "" });
    },

    removeGrade: function removeGrade() {
      this.grades.pop();
    },

    initGrades: function initGrades() {
      for (var i = 0; i < 10; i++) {
        this.grades.push({ "pointsEarned": "", "pointsTotal": "", "weight": "" });
      }
    },

    resetEntries: function resetEntries() {
      for (var g in this.grades) {
        this.grades[g].pointsEarned = "";
        this.grades[g].pointsTotal = "";
        this.grades[g].weight = "";
      }
      this.weightGrade = "";
    },

    resetPred: function resetPred() {

      this.final.finalTotal = "";
      this.final.finalWeight = "";

      this.predictedGrade = "";
      this.value = 0;
    }
  },

  computed: {
    calculateGrade: function calculateGrade() {

      var earnedTotal = 0;
      var weightSum = 0;
      for (var g in this.grades) {
        if (this.grades[g].pointsEarned === "" || this.grades[g].pointsTotal === "" || this.grades[g].weight === "") {
          continue;
        } else {
          var earned = Number(this.grades[g].pointsEarned);
          var total = Number(this.grades[g].pointsTotal);
          var weight = Number(this.grades[g].weight);

          earnedTotal += parseFloat(earned / total) * weight;
          weightSum += weight;
        }
      }

      this.weightSum = weightSum;
      this.earnedTotal = earnedTotal.toFixed(2);
      var weightGrade = earnedTotal / weightSum * 100;
      this.weightGrade = weightGrade.toFixed(2);

      if (isNaN(this.weightGrade)) {
        return 0;
      } else if (!isFinite(this.weightGrade)) {
        return 0;
      }
      return this.weightGrade;
    },

    predictGrade: function predictGrade() {

      var need = 0;
      var totalSum = Number(this.weightSum) + Number(this.final.finalWeight);
      var parsedWeight = this.value / 100.0;

      need = Math.ceil((parsedWeight * totalSum - Number(this.earnedTotal)) / Number(this.final.finalWeight) * Number(this.final.finalTotal));
      this.predictedGrade = need;

      if (need < 0) {
        return 0;
      } else {
        if (!isFinite(need)) {
          return 0;
        }
      }
      return need;
    }
  },

  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loyola.d384cad.png";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/northwestern.dc7da4b.png";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(11)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(22),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e0d9fc7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(24),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8b08c8ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(23),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29a6ad46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(26),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e1fc5086",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gradeCalcPage"
  }, [_c('div', {
    staticClass: "entries"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "header"
  }, [_vm._v("  Earned    Total")]), _vm._v(" "), _c('div', {
    staticClass: "cummGrades"
  }, _vm._l((_vm.grades), function(grade) {
    return _c('div', {
      staticClass: "grade"
    }, [_vm._v("\n  \t       "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.pointsEarned),
        expression: "grade.pointsEarned"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.pointsEarned)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.pointsEarned = $event.target.value
        }
      }
    }), _vm._v("  \n  \t      "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.pointsTotal),
        expression: "grade.pointsTotal"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.pointsTotal)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.pointsTotal = $event.target.value
        }
      }
    })])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.addGrade
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.removeGrade
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.resetEntries
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('div', {
    staticClass: "output"
  }, [_c('h3', [_vm._v(" Your grade is " + _vm._s(_vm.calculateGrade) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "predGrade"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Enter remaining point category totals: ")]), _vm._v(" "), _c('div', {
    staticClass: "gradesToGo"
  }, _vm._l((_vm.predicts), function(grade) {
    return _c('div', {
      staticClass: "grade"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.pointsPredict),
        expression: "grade.pointsPredict"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.pointsPredict)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.pointsPredict = $event.target.value
        }
      }
    })])
  })), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Enter/Slide Desired Grade:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 0,
      "max": 100,
      "width": 500
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.resetPred
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('div', {
    staticClass: "predOutput"
  }, [_c('h3', [_vm._v(" You need " + _vm._s(_vm.predictGrade) + " points to get a " + _vm._s(_vm.value) + "% in the class.")])])], 1), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('u', [_vm._v("Current Grade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "predHeader"
  }, [_c('u', [_vm._v("Predicted Grade")])])
}]}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gradeCalcPage"
  }, [_c('div', {
    staticClass: "logos"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(16)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(17)
    }
  })])])
}]}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gradeCalcPage"
  }, [_c('div', {
    staticClass: "entries"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "previousResults"
  }, [_vm._v(" Previous grade information:")]), _vm._v(" "), _c('div', {
    staticClass: "existingGrades"
  }, [_c('p', [_vm._v("GPA: \n  \t      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prevGPA),
      expression: "prevGPA"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.prevGPA)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prevGPA = $event.target.value
      }
    }
  }), _vm._v("\n  \t        Credit Hours: \n  \t      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prevCreditHours),
      expression: "prevCreditHours"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.prevCreditHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prevCreditHours = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "header"
  }, [_vm._v("  Letter    Credit Hours")]), _vm._v(" "), _c('div', {
    staticClass: "gpaGrades"
  }, _vm._l((_vm.grades), function(grade) {
    return _c('div', {
      staticClass: "grade"
    }, [_vm._v("\n  \t       "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.letter),
        expression: "grade.letter"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.letter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.letter = $event.target.value
        }
      }
    }), _vm._v("\n  \t         "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.creditHours),
        expression: "grade.creditHours"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.creditHours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.creditHours = $event.target.value
        }
      }
    })])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.addGrade
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.removeGrade
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.resetEntries
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('div', {
    staticClass: "output"
  }, [_c('h3', [_vm._v(" Your GPA is " + _vm._s(_vm.calculateGrade))])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "predGrade"
  }, [_vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Enter remaining credit hours: ")]), _vm._v(" "), _c('div', {
    staticClass: "gradesToGo"
  }, [_c('div', {
    staticClass: "grade"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.final.creditHours),
      expression: "final.creditHours"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.final.creditHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.final.creditHours = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Enter/Slide Desired GPA:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 3.00,
      "max": 4.00,
      "interval": .01,
      "width": 500
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.resetPred
    }
  }, [_vm._v("Reset")])], 1), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "predOutput"
  }, [_c('h3', [_vm._v(" You need an average GPA of " + _vm._s(_vm.predictGrade) + " to get a " + _vm._s(_vm.value))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('u', [_vm._v("Current Grade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gpaDisplay"
  }, [_c('table', {
    staticClass: "gpaTable"
  }, [_c('thead', [_c('tr', {
    staticClass: "gpaHeader"
  }, [_c('th', [_vm._v("Letter")]), _c('th', [_vm._v("GPA")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("A")]), _c('th', [_vm._v("4.00")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("A-")]), _c('th', [_vm._v("3.67")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("B+")]), _c('th', [_vm._v("3.33")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("B")]), _c('th', [_vm._v("3.00")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("B-")]), _c('th', [_vm._v("2.67")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("C+")]), _c('th', [_vm._v("2.33")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("C")]), _c('th', [_vm._v("2.00")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("C-")]), _c('th', [_vm._v("1.67")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("D+")]), _c('th', [_vm._v("1.33")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("D")]), _c('th', [_vm._v("1.00")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("D-")]), _c('th', [_vm._v("0.67")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("F")]), _c('th', [_vm._v("0.00")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "predHeader"
  }, [_c('u', [_vm._v("Predicted Grade")])])
}]}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v(" Grade Calculator ")]), _vm._v(" "), _c('div', {
    staticClass: "buttonNav"
  }, [_c('button', {
    staticClass: "btn-primary",
    on: {
      "click": function($event) {
        _vm.goToPage('Cummulative')
      }
    }
  }, [_vm._v("Cummulative")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": function($event) {
        _vm.goToPage('Weight')
      }
    }
  }, [_vm._v("Weight")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": function($event) {
        _vm.goToPage('GPA')
      }
    }
  }, [_vm._v("GPA")])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gradeCalcPage"
  }, [_c('div', {
    staticClass: "entries"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "header"
  }, [_vm._v("  Earned    Total       Weight")]), _vm._v(" "), _c('div', {
    staticClass: "weightGrades"
  }, _vm._l((_vm.grades), function(grade) {
    return _c('div', {
      staticClass: "grade"
    }, [_vm._v("\n  \t       "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.pointsEarned),
        expression: "grade.pointsEarned"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.pointsEarned)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.pointsEarned = $event.target.value
        }
      }
    }), _vm._v("\n  \t        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.pointsTotal),
        expression: "grade.pointsTotal"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.pointsTotal)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.pointsTotal = $event.target.value
        }
      }
    }), _vm._v("\n  \t        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.weight),
        expression: "grade.weight"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.weight = $event.target.value
        }
      }
    })])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.addGrade
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.removeGrade
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.resetEntries
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('div', {
    staticClass: "output"
  }, [_c('h3', [_vm._v(" Your grade is " + _vm._s(_vm.calculateGrade) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "predGrade"
  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Enter final grade info: ")]), _vm._v(" "), _c('div', {
    staticClass: "gradesToGo"
  }, [_c('p', {
    staticClass: "header"
  }, [_vm._v("  Total        Weight")]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.final.finalTotal),
      expression: "final.finalTotal"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.final.finalTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.final.finalTotal = $event.target.value
      }
    }
  }), _vm._v("\n  \t        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.final.finalWeight),
      expression: "final.finalWeight"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.final.finalWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.final.finalWeight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Enter/Slide Desired Grade:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 0,
      "max": 100,
      "width": 500
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.resetPred
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('div', {
    staticClass: "predOutput"
  }, [_c('h3', [_vm._v(" You need " + _vm._s(_vm.predictGrade) + " points to get a " + _vm._s(_vm.value) + "% in the class.")])])], 1), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('u', [_vm._v("Current Grade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "predHeader"
  }, [_c('u', [_vm._v("Predicted Grade")])])
}]}

/***/ })
],[10]);


// WEBPACK FOOTER //
// static/js/app.b5e00deb07d951aa8b8a.js